
import { useEditorContext } from "../providers/hekProvider";
import React, { Component, useEffect, useState, useRef } from 'react'
import { ApiAdress } from './GlobalSettings.js';
import axios from "axios";
import qs from "qs";
import { Accordion, Card } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/comp.css';
import { GetAllPageByIssueID, GetPageImage, PageOrderSave, GetPageByID, getImageListByPAge, GlobalUrl } from '../db/db';
import { Form, Col, Row, Button, Modal, ProgressBar } from "react-bootstrap";
import { FaFileAlt, FaBraille, FaRegHandRock } from 'react-icons/fa';
import NewPage from "./NewPage";
//dnd
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import PageProperties from "./PageProperties";
import { editorTool } from "../providers/useIndex";


const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    PageOrderSave(result[startIndex].id, startIndex, removed.id, endIndex)
    return result;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({

    userSelect: "none",
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,


    background: isDragging ? "lightgreen" : "grey",


    ...draggableStyle
});

const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? "lightblue" : "lightgrey",
    padding: grid,
    width: 250
});



//dnd


const PageComp = (props) => {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const QIssueIDData = (window.location.search.split("?MID=")[1] != undefined) ? window.location.search.split("?MID=")[1] : window.location.pathname.split('/')[1]
    const { editor, pages, myEditor, MagazineID, selectedPageProps, setselectedPageProps, pageSlide, ReloadSlide, showDetail, setshowDetail, setPages, GetSelectedPage } = useEditorContext();
    const [pageinit, setPageinit] = useState();
    const [QIssueID, setQIssueID] = useState(QIssueIDData)
    const [DetailPage, setDetailPage] = useState()
    const [ModalProp, setModalProp] = useState({ title: "title", message: "messaj" })
    const [Pcount, setPcount] = useState(10)
    const AllPage = async () => {

        const PageData = await GetAllPageByIssueID(QIssueID)
        setPages(PageData)



    }

    const ModalOpen = (ModalTitle, ModalMessage) => {
        setModalProp({
            title: ModalTitle,
            message: ModalMessage
        })
        setShow(true)
    }


    useEffect(() => {
        AllPage();

    }, [pageinit])


    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{ModalProp.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {ModalProp.message}
                    <ProgressBar striped variant="danger" now={Pcount} /></Modal.Body>

            </Modal>
            <Button className="btn-light col-12" style={{ margin: "5px" }} size="sm" onClick={() => { setShow(true) }}>
                <FaFileAlt />
                Yeni Sayfa Oluştur
            </Button>
            <DragDropContext onDragEnd={(result) => {
                if (!result.destination) {
                    return;
                }

                const items = reorder(
                    pages,
                    result.source.index,
                    result.destination.index
                );

                setPages([...items])


            }}>

                <Droppable droppableId="droppable" >
                    {(provided, snapshot) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}>
                            {pages.map((item, index) => (
                                <Draggable key={item.id} draggableId={item.id.toString()} index={index} style={{ "width": "100%" }}>
                                    {(provided, snapshot) => (
                                        <div className="PageListContainer" ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            id={item.id}>
                                            <div className="PageItem" onClick={async () => {
                                                console.log("OwnerTest", item)
                                                await GetSelectedPage(item.id).then(() => {
                                                    document.getElementById("PropetiesContainer").style.display = "block"

                                                })
                                            }}>
                                                <div><FaBraille /></div>
                                                <div>{item.name}</div>
                                            </div>

                                        </div>
                                    )}
                                </Draggable>
                            ))}



                        </div>)}
                </Droppable>

            </DragDropContext>


            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Yeni Sayfa</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <NewPage QIssueID={QIssueID} pageLoad={AllPage} handleClose={handleClose} />

                </Modal.Body>

            </Modal>

        </>
    )
}

export default PageComp
